import React, { useEffect, useContext } from 'react';
import { Form, Col, Row } from 'react-bootstrap';
import { useParams } from 'react-router';
import CronJobEditor from '../../Utils/CronJobEditor';
import AppContext from 'Utils/AppContext';

const MaskingEditor = ({ integration, setIntegration }) => {
  // const { rulesList } = useContext(AppContext);
  // const { id } = useParams();

  // const defaultRules = rulesList.find(rules => rules.default === true);

  // const defaults = {
  //   name: '',
  //   host: '',
  //   user: '',
  //   password: '',
  //   port: 80,
  //   ...!id && ({
  //     scheduleExpression: '0 0 ? * SAT#1 *',
  //     scheduleRules: defaultRules
  //   })
  // }
  
  // useEffect(() => { if (!id) setConnection(defaults); }, []);
  return (
    <div className='text-left'>
      <Row className='mb-3'>
        <Col>
          <Form.Label>Integration Name *</Form.Label>
          <Form.Control 
            size='sm'
            // disabled={id}
            placeholder='Sample Integraito'
            value={integration.name}
            onChange={(n) => setIntegration({ ...integration, name: n.target.value })}
            type='text'
            required
            isInvalid={integration && integration.name && integration.name.length < 8}
          />
          <Form.Control.Feedback type="invalid">
            Integration names must be at least 8 characters long.
          </Form.Control.Feedback>
        </Col>
      </Row>
      <Row className='mb-3'>
        <Col>
          <Form.Label>Location</Form.Label>
          <Form.Control 
            size='sm'
            placeholder='https://engine.location.com'
            value={integration.location}
            onChange={(n) => setIntegration({ ...integration, location: n.target.value })}
            type='text'
            required
          />
        </Col>
        <Col xs={2}>
          <Form.Label>Port</Form.Label>
          <Form.Control
            size='sm'
            placeholder='Port'
            value={integration.port}
            onChange={(n) => setIntegration({ ...integration, port: n.target.value })}
            required
          />
        </Col>
      </Row>
      <Row className='mb-3'>
        <Col lg='6'>
          <Form.Label>Username *</Form.Label>
          <Form.Control
            size='sm'
            type='text'
            value={integration.username}
            onChange={(n) => setIntegration({ ...integration, username: n.target.value})}
            placeholder='Username'
            required
            autoComplete='new-password'
          />
        </Col>
        <Col lg='6'>
          <Form.Label>Password *</Form.Label>
          <Form.Control
            size='sm'
            type='password'
            value={integration.password}
            placeholder='Password'
            onChange={(n) => setIntegration({ ...integration, password: n.target.value })}
            required
            autoComplete='new-password'
          />
        </Col>
      </Row>

    </div>
  );
}

export default MaskingEditor;
